import { createResource } from '@atlassian/react-resource-router';

type LinkedSpace = {
	linkedSpaceId: number;
	spaceKey: string;
	spaceName: string;
	spaceUrl?: string;
	spaceSettingsUrl?: string;
};

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-servicedesk-virtual-agent-ai-answers", jiraSpaEntry: "async-resource-servicedesk-virtual-agent-ai-answers" */ './get-data'
	);

export const servicedeskVirtualAgentAiAnswersKbResource = createResource<LinkedSpace[]>({
	type: 'SERVICEDESK_VIRTUAL_AGENT_AI_ANSWERS_KB_RESOURCE',
	getKey: ({ match: { params } }) => params.projectKey || '',
	getDataLoader,
	isBrowserOnly: true, // remove when apollo sorts our permissions to linked-spaces API
});
